/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcsSourceProperties } from '../models/GcsSourceProperties';
import { IngestionPipelineStatus } from '../models/IngestionPipelineStatus';
import { IngestionSourceType } from '../models/IngestionSourceType';
import { S3SourceProperties } from '../models/S3SourceProperties';

export class IngestionPipeline {
  /**
  * The unique identifier of the ingestion pipeline
  */
  'id': string;
  /**
  * The name of the ingestion pipeline
  */
  'name': string;
  /**
  * The namespace for the ingestion pipeline
  */
  'namespace': string;
  /**
  * The table name for the ingestion pipeline
  */
  'tableName': string;
  'sourceType': IngestionSourceType;
  's3SourceProperties'?: S3SourceProperties;
  'gcsSourceProperties'?: GcsSourceProperties;
  'status': IngestionPipelineStatus;
  /**
  * Error message from the last failed operation
  */
  'failureMessage'?: string;
  /**
  * The timestamp when the ingestion pipeline was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the ingestion pipeline was last updated
  */
  'updatedAt'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "namespace",
      "baseName": "namespace",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "tableName",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceType",
      "baseName": "sourceType",
      "type": "IngestionSourceType",
      "format": ""
    },
    {
      "name": "s3SourceProperties",
      "baseName": "s3SourceProperties",
      "type": "S3SourceProperties",
      "format": ""
    },
    {
      "name": "gcsSourceProperties",
      "baseName": "gcsSourceProperties",
      "type": "GcsSourceProperties",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "IngestionPipelineStatus",
      "format": ""
    },
    {
      "name": "failureMessage",
      "baseName": "failureMessage",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return IngestionPipeline.attributeTypeMap;
  }

  public constructor() {
  }
}



